import React from 'react'
import {
  BulkDeleteWithConfirmButton,
  BulkExportButton,
  Exporter,
  useListContext,
} from 'react-admin'
import exportFormatter from 'services/csv/exporter'

const DeleteAndExportBulk: React.FC = () => {
  const { selectedIds } = useListContext()

  return (
    <React.Fragment>
      <BulkExportButton
        selectedIds={selectedIds}
        exporter={exportFormatter(true) as Exporter}
      />
      <BulkDeleteWithConfirmButton mutationMode="optimistic" />
    </React.Fragment>
  )
}
export default DeleteAndExportBulk
